// Copied from https://github.com/langchain-ai/langchainjs/blob/82c188140e357b7502868876af1957f6c401986b/langchain-core/src/utils/tiktoken.ts
import {
  Tiktoken,
  TiktokenEncoding,
  TiktokenModel,
  getEncodingNameForModel,
} from "js-tiktoken/lite";
import { AsyncCaller } from "./async-caller";

const cache: Record<string, Promise<Tiktoken>> = {};

const caller = /* #__PURE__ */ new AsyncCaller({});

export type { TiktokenModel };

async function getEncoding(encoding: TiktokenEncoding) {
  if (!(encoding in cache)) {
    cache[encoding] = caller
      .fetch(`https://tiktoken.pages.dev/js/${encoding}.json`)
      .then((res) => res.json())
      .then((data) => new Tiktoken(data))
      .catch((e) => {
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete cache[encoding];
        throw e;
      });
  }

  return await cache[encoding];
}

export async function encodingForModel(model: TiktokenModel) {
  // We use Tiktoken to get the encoding for the model, however
  // we don't want to be bound to the models supported by Tiktoken.
  // If the model is not supported by Tiktoken, we fall back to gpt-4o's encoding, o200k_base.
  let encodingName;
  try {
    encodingName = getEncodingNameForModel(model);
  } catch {
    encodingName = getEncodingNameForModel("gpt-4o");
  }
  return getEncoding(encodingName);
}
